module.exports = __webpack_public_path__ + "img/glutes-wfh-stretches.2bca3203.jpg";